'use client';

import React from 'react';
import { Button } from '@heroui/button';
import {
  FaTriangleExclamation,
  FaRotateRight,
  FaEnvelope,
  FaPhone,
} from 'react-icons/fa6';

interface ErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function Error({ error, reset }: ErrorProps) {
  return (
    <div className='h-full w-full bg-gray-50 px-4 py-8'>
      <div className='flex min-h-[60vh] items-center justify-center'>
        <div className='rounded-lg border bg-white p-8 text-center shadow-lg'>
          <div className='mb-6 flex justify-center'>
            <div className='rounded-full bg-red-100 p-4'>
              <FaTriangleExclamation className='h-12 w-12 text-red-500' />
            </div>
          </div>

          <h1 className='mb-4 text-2xl font-semibold text-gray-800'>
            Something went wrong
          </h1>

          <p className='mb-6 text-gray-600'>
            We encountered an error while loading your quote. This is usually
            temporary.
          </p>

          <div className='mb-6 flex flex-col gap-3 sm:flex-row sm:justify-center'>
            <Button
              variant='shadow'
              color='primary'
              className='font-bold uppercase'
              startContent={<FaRotateRight />}
              onPress={reset}
            >
              Try Again
            </Button>
          </div>

          {/* <div className='border-t pt-6'>
            <h3 className='mb-4 text-lg font-semibold text-gray-800'>
              Need Help?
            </h3>
            <p className='mb-4 text-sm text-gray-600'>
              If this problem persists, please contact us directly:
            </p>
            <div className='space-y-2 text-sm text-gray-600'>
              <div className='flex items-center justify-center gap-2'>
                <FaEnvelope className='h-4 w-4 text-gray-400' />
                <a
                  href='mailto:support@example.com'
                  className='hover:text-blue-600 hover:underline'
                >
                  support@example.com
                </a>
              </div>
              <div className='flex items-center justify-center gap-2'>
                <FaPhone className='h-4 w-4 text-gray-400' />
                <a
                  href='tel:+1-555-123-4567'
                  className='hover:text-blue-600 hover:underline'
                >
                  (555) 123-4567
                </a>
              </div>
            </div>
          </div> */}

          {process.env.NODE_ENV === 'development' && (
            <details className='mt-6 text-left'>
              <summary className='cursor-pointer text-sm text-gray-500 hover:text-gray-700'>
                Error Details (Development)
              </summary>
              <pre className='mt-2 overflow-auto rounded bg-gray-100 p-2 text-xs text-gray-700'>
                {error.message}
                {error.stack}
              </pre>
            </details>
          )}
        </div>
      </div>
    </div>
  );
}
